module.exports = __webpack_public_path__ + "img/kefu.6396f91a.jpg";